import React, { useState, useEffect } from 'react'
import { Container } from '@orbitalgaming/games-frontend-library'
import { cyberColors } from '../../lib/colors'
import { PageWrapper } from './SettingsStyle'
import PageHeader from '../header/Header'
import Pages from './Pages'
import AudioComponent from './audio/Audio'

export default function Settings({
  handleAbove,
  unBlur,
  handleAudio,
  audioForSocket,
  audio,
}: any) {
  const [music, setMusic] = useState<string>('50')
  const [sound, setSound] = useState<string>('50')
  const [isMusicOff, setisMusicOff] = useState<boolean>(false)
  const [isSoundOff, setisSoundOff] = useState<boolean>(false)

  const [socketSound, setsocketSound] = useState<string>(audioForSocket.sound)
  const [socketMusic, setsocketMusic] = useState<string>(audioForSocket.music)

  useEffect(() => {
    setisMusicOff(audioForSocket.isMusicOff)
    setisSoundOff(audioForSocket.isSoundOff)
    setSound(audioForSocket.sound)
    setMusic(audioForSocket.music)
    setsocketSound(audioForSocket.sound)
    setsocketMusic(audioForSocket.music)
  }, [audioForSocket])

  const handleClose = () => {
    // handleAudio({ sound, music, isMusicOff, isSoundOff })
    handleAbove(false)
  }

  const focusHandler = (e: any) => {
    !e && handleAudio({ sound, music, isMusicOff, isSoundOff })
  }

  return (
    <Container
      unBlur={unBlur}
      backgroundColor={cyberColors.black}
      padding={'21px 30px 10px'}
    >
      <PageHeader title={'settings'} func={() => handleClose()} audio={audio} />
      <PageWrapper>
        <Pages handleAbove={handleAbove} />
      </PageWrapper>
      <AudioComponent
        title={'music'}
        setVolume={setMusic}
        volume={music}
        mute={isMusicOff}
        setMute={setisMusicOff}
        socketValue={socketMusic}
        focusHandler={focusHandler}
      />
      <AudioComponent
        title={'sound'}
        setVolume={setSound}
        volume={sound}
        mute={isSoundOff}
        setMute={setisSoundOff}
        socketValue={socketSound}
        focusHandler={focusHandler}
      />
    </Container>
  )
}
